var $scope, $timeout, socket, $translate, serviceSession, serviceNotification, eventSender;

class UserAlarmController {

	constructor(_$scope, _$timeout, _socket, _$translate, _serviceSession, _serviceNotification, _eventSender) {
		$scope = _$scope;
		$timeout = _$timeout;
		socket = _socket;
		serviceSession = _serviceSession;
		serviceNotification = _serviceNotification;
		$translate = _$translate;
		eventSender = _eventSender;

		$scope.search = {};
		$scope.dataCodes = [];
		$scope.isV4Enabled = Araqne.isV4Enabled;

		$scope.$on('orgchartOnSelectUser', this.onSelectUser.bind(this));
		$scope.$on('orgchartOnEditSelectedUser', this.onEditSelectedUser.bind(this));
		$scope.$on('orgchartOnDiscardUserInfo', this.onDiscardUserInfo.bind(this));
		$scope.$on('orgchartOnRefreshUser', this.onRefreshUser.bind(this));
		$scope.onSaveForm = this.onSaveForm.bind(this);

		this.getCodes();

		eventSender.orgchart.onChangeAdminForUserAlarm = this.onChangeAdminForUserAlarm.bind(this);

		$scope.canAcceptAlarm = this.canAcceptAlarm.bind(this);
	}

	onDiscardUserInfo() {
		this.rolename = this.currentUser.ext.admin.role.name;
		this.currentUser = null;
	}

	checkAdmin(rolename) {
		if(rolename === 'master' || rolename === 'admin') {
			return true;
		}
		else {
			return false;
		}
	}

	canAcceptAlarm() {
		if(!!this.rolename) {
			return this.checkAdmin(this.rolename)
		}
		else {
			if(!!this.currentUser && !!this.currentUser.ext.admin.role) {
				return this.checkAdmin(this.currentUser.ext.admin.role.name);
			}
			else {
				return false;
			}
		}
	}

	onChangeAdminForUserAlarm(rolename) {
		this.rolename = rolename;
	}

	onSaveForm(user) {
		var self = this;
		return (resolve) => {
			socket.send('com.logpresso.core.msgbus.AlertPlugin.setSubscriptions', {
				'subscriptions': {
					'login_name': user.login_name,
					'subscriptions': self.buildSubscriptions()
				}
			}, 0)
			.success((m) => {
				$scope.dataCodes = angular.copy($scope.dataCodesCopy);
				if(serviceSession.whoAmI() === user.login_name) {
					serviceNotification.updateMySubscriptions();
				}
				resolve('setSubscriptions success');
			});
		}
	}

	onSelectUser(e, user) {
		this.rolename = null;
		this.currentUser = user;
		if(this.currentUser.ext.admin.use_logout_timeout === true){
			this.currentUser.ext.admin.use_idle_timeout = 'logout';
		}
		this.getSubscriptions(user.login_name);
	}

	onRefreshUser(e, user) {
		this.getSubscriptions(user.login_name);
	}

	onEditSelectedUser(e, user) {
		this.rolename = null;
		this.currentUser = user;

		if(this.currentUser.ext.admin.use_logout_timeout === true){
			this.currentUser.ext.admin.use_idle_timeout = 'logout';
		}

		if(!!user._isNew){
			$scope.dataCodes.forEach((code) => {
				for(var attr in code) {
					if(/^use_(\w)+/.test(attr)) {
						code[attr] = false;
					}
				}
			});
		}else{
			if(!this.canAcceptAlarm()){
				$scope.dataCodes.forEach((code) => {
					for(var attr in code) {
						if(/^use_(\w)+/.test(attr)) {
							code[attr] = false;
						}
					}
				});
			}

		}
		$scope.dataCodesCopy = angular.copy($scope.dataCodes);
	}

	getCodes() {
		return socket.send('com.logpresso.core.msgbus.AlertPlugin.getCodes', {'locale':$translate.use() }, 1)
		.success((m) => {
			// console.log(m);

			$scope.dataCodes = m.body.codes;
			$scope.dataCategories = m.body.codes.map((code) => {
				return code.category;
			}).unique();

			$scope.search = { 'category': $scope.dataCategories[0] };

			$scope.$digest();
		});
	}

	buildSubscriptions() {
		var self = this;
		return $scope.dataCodesCopy.map(function(code){
			var use_popup = code.use_popup;
			var use_mail = code.use_mail;
			// check authority(member)
			if(!self.canAcceptAlarm()){
				use_popup = false;
				use_mail  = false;
			}
			return {
				'code': code.code,
				'use_popup': use_popup,
				'use_mail': use_mail
			}
		});
	}

	getSubscriptions(user) {
		if(!user) {
			return;
		}

		socket.send('com.logpresso.core.msgbus.AlertPlugin.getSubscriptions', { 'login_name': user }, 1)
		.success((m) => {
			// console.log(m, this);
			if(!angular.isObject(m.body.subscriptions)) {
				$scope.dataCodes.forEach((code) => {
					for(var attr in code) {
						if(/^use_(\w)+/.test(attr)) {
							code[attr] = false;
						}
					}
				});
			}
			else {
				m.body.subscriptions.subscriptions.forEach((sub) => {
					var found = $scope.dataCodes.filter((code) => {
						return code.code === sub.code;
					});
					if(found.length > 0) {
						for(var attr in sub) {
							found[0][attr] = sub[attr];
						}
					}
					else {
						console.log(user, ' has no code subscriptions info');
					}
				});
			}
			$scope.$digest();
		});
	}
}

UserAlarmController.$inject = ['$scope', '$timeout', 'socket', '$translate', 'serviceSession', 'serviceNotification', 'eventSender'];

export default UserAlarmController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/orgchart/controller.UserAlarm.es6.js